import Vue from 'vue'
import { Tab, Tabs, Switch, CellGroup, Cell, Cascader, Popup, Form, Field, Checkbox, Dialog, ActionSheet, Rate, Icon, Grid, GridItem, Swipe, SwipeItem, Search, Toast, NavBar, Tabbar, TabbarItem, Button, Loading } from 'vant'
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Switch)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Cascader)
Vue.use(Popup)
Vue.use(Form)
Vue.use(Field)
Vue.use(Checkbox)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(Rate)
Vue.use(Icon)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Search)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Button)
Vue.use(Loading)
